/* Subscribe to active announcements and expose a dismiss callback. */

import { useQuery, useMutation } from "convex/react";
import { api } from "../../convex/_generated/api";
import type { Id } from "../../convex/_generated/dataModel";

export function useAnnouncements() {
	const announcements = useQuery(api.announcements.getActive, {
		appVersion: __APP_VERSION__,
		platform: "web",
	});
	const dismissMutation = useMutation(api.announcements.dismiss);

	const dismiss = (announcementId: Id<"announcements">) => {
		dismissMutation({ announcementId });
	};

	return { announcements, dismiss };
}
